import React, { FC } from "react";
import { ChatMessageProps } from "./typing";
import Markdown from "react-markdown";

const ChatMessageShadcn: FC<ChatMessageProps> = ({ message, streaming, handleSuggestionClick, handleDismiss, previousStep }) => {
  const isUser = message.role === "user";
  const isThinking = !isUser && streaming && !message.content;
  const isTicketSuccess = (message as any).ticketSuccess === true;
  const isSuggestion = message.role === 'suggestion';
  const bubbleClass = {
    user: "chat-msg-bubble--user",
    assistant: "chat-msg-bubble--bot",
    suggestion: "chat-msg-bubble--suggestion",
  };
  const roleClass = {
    user: "chat-msg--user",
    assistant: "chat-msg--bot",
    suggestion: "chat-msg--suggestion",
  };
  const bubbleRoleClass = bubbleClass[message.role] || "";
  const roleMsgClass = roleClass[message.role] || "";
  return (
    <div className={`chat-msg ${roleMsgClass} ${isTicketSuccess ? 'chat-msg--ticket-success' : ''}`}>
      <div className={`chat-msg-bubble ${bubbleRoleClass}`} onClick={() => handleSuggestionClick?.()}>
        {isTicketSuccess && (
          <div className="chat-ticket-success-icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <circle cx="10" cy="10" r="10" fill="#0EAD69" />
              <path d="M6 10l2.5 2.5L14 7" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
        )}
        <div className="chat-ticket-success-text">
          {isThinking ? <div className="chat-msg-typing">...</div> : <Markdown>{message.content}</Markdown>}
          {!isThinking && streaming && <span className="chat-msg-cursor" />}
        </div>
        {isSuggestion && handleDismiss && (
          <button className="chat-suggestion-dismiss" onClick={(e) => { e.stopPropagation(); handleDismiss(); }}>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="#AEAEAE" strokeWidth="1.5" strokeLinecap="round">
              <line x1="1" y1="1" x2="11" y2="11" />
              <line x1="11" y1="1" x2="1" y2="11" />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};
export default ChatMessageShadcn;
